<template>
  <div :id="id" :class="['check', { 'check--active' : checked, 'check--clickable' : hasLink }, getTheme]">
    <div  class="check__circle" tabindex="0" @click="onClick" @keydown.enter="onClick"></div>
    <div v-if="!hasLink" :id="id + '-link'" class="check__text" @click="onClick" >
      {{ item.Text }}
    </div>
    <a v-else :id="id + '-text'" class="check__text check__text-link" :href="item.Url" target="_blank" @keyup.enter="onEnter" >
      {{ item.Text }}
    </a>
  </div>
</template>

<script>
export default {
  name: 'nt-form-check',
  props: {
    id: {
      type: String,
      default: 'check'
    },
    item: {
      type: Object,
      required: true,
      validator(val) {
        return Object.hasOwnProperty.call(val, 'Text') &&
               Object.hasOwnProperty.call(val, 'Value')
      }
    },
    theme: {
      type: String,
      default: 'default'
    },
  },
  data() {
    return {
      checked: false
    }
  },
  computed: {
    getTheme() {
      return `check--${this.theme}`
    },
    hasLink() {
      return !!this.item.Url
    }
  },
  methods: {
    onEnter() {
      event.stopPropagation()
      window.open(this.item.Url, '_blank')
    },
    onClick() {
      this.checked = !this.checked

      this.$emit('onSelect', {
        Text: this.item.Text,
        Value: this.item.Value,
        Checked: this.checked
      })
    }
  }
}
</script>

<style lang="scss" scoped>
  .check {
    $container: &;
    display: flex;
    align-items: flex-start;

    &:hover {
      cursor: pointer;
    }

    &__circle {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 18px;
      height: 18px;
      min-width: 18px;
      min-height: 18px;
      padding: 2px;
      margin-right: 10px;
      border: 1px solid #CCC;
    }

    &__text {
      font-size: 18px;
      line-height: 18px;
      letter-spacing: -1px;
      color: rgb(62, 59, 55);
      // white-space: nowrap;
      text-decoration: none;

      // &-link {
      //   text-decoration: underline;
      // }
    }

    &--clickable {
      #{$container}__text {
        &:hover {
          text-decoration: underline;
        }
      }
    }

    &--active {
      #{$container}__circle {
        &::before {
          content: '';
          width: 100%;
          height: 100%;
          background: #9ddda9;
        }
      }
    }
    
    &--small {
      #{$container}__circle {
        min-width: 16px;
        min-height: 16px;
        width: 16px;
        height: 16px;
      }

      #{$container}__text {
        font-size: 1rem;
        line-height: 16px;
      }
    }
  }
</style>

